import { Theme } from '@models/Theme';

export const defaultTheme: Theme = {
  cardBgColor: '#ffffff',
  cardDetailsBackGround: '#ffffff',
  cardDetailsColor: '#374151',
  cardMediaBgColor: '#f8fafc',
  cardSubtitleColor: '#6b7280',
  cardTitleColor: '#007FFF',
  detailsColor: '#374151',
  iconBackgroundColor: '#007FFF',
  nestedCardBgColor: '#f8fafc',
  nestedCardDetailsBackGround: '#f8fafc',
  nestedCardDetailsColor: '#374151',
  nestedCardSubtitleColor: '#6b7280',
  nestedCardTitleColor: '#1f2937',
  primary: '#007FFF',
  secondary: '#ffdf00',
  titleColor: '#007FFF',
  titleColorActive: '#007FFF',
  toolbarBgColor: '#f1f5f9',
  toolbarBtnBgColor: '#ffffff',
  toolbarTextColor: '#1e293b',
  timelineBgColor: '#ffffff',

  // Light mode styling
  iconColor: '#007FFF',
  buttonHoverBgColor: '#e2e8f0',
  buttonActiveBgColor: '#007FFF',
  buttonActiveIconColor: '#ffffff',
  buttonBorderColor: '#e2e8f0',
  buttonHoverBorderColor: '#007FFF',
  buttonActiveBorderColor: '#007FFF',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  glowColor: 'rgba(0, 127, 255, 0.2)',
  searchHighlightColor: 'rgba(0, 127, 255, 0.2)',
  darkToggleActiveBgColor: '#007FFF',
  darkToggleActiveIconColor: '#ffffff',
  darkToggleActiveBorderColor: '#007FFF',
  darkToggleGlowColor: 'rgba(0, 127, 255, 0.2)',
};

export const darkTheme: Theme = {
  cardBgColor: '#1f2937',
  cardDetailsBackGround: '#1f2937',
  cardDetailsColor: '#f3f4f6',
  cardMediaBgColor: '#111827',
  cardSubtitleColor: '#d1d5db',
  cardTitleColor: '#60a5fa',
  detailsColor: '#f3f4f6',
  iconBackgroundColor: '#3b82f6',
  nestedCardBgColor: '#111827',
  nestedCardDetailsBackGround: '#111827',
  nestedCardDetailsColor: '#f3f4f6',
  nestedCardSubtitleColor: '#d1d5db',
  nestedCardTitleColor: '#f9fafb',
  primary: '#3b82f6',
  secondary: '#fbbf24',
  titleColor: '#60a5fa',
  titleColorActive: '#60a5fa',
  toolbarBgColor: '#111827',
  toolbarBtnBgColor: '#374151',
  toolbarTextColor: '#f3f4f6',
  timelineBgColor: '#111827',

  // Dark mode styling - our enhanced colors as defaults
  iconColor: '#93c5fd',
  buttonHoverBgColor: '#4b5563',
  buttonActiveBgColor: '#fbbf24',
  buttonActiveIconColor: '#1f2937',
  buttonBorderColor: 'rgba(255, 255, 255, 0.1)',
  buttonHoverBorderColor: '#3b82f6',
  buttonActiveBorderColor: '#3b82f6',
  shadowColor: 'rgba(0, 0, 0, 0.4)',
  glowColor: 'rgba(59, 130, 246, 0.4)',
  searchHighlightColor: 'rgba(96, 165, 250, 0.4)',
  darkToggleActiveBgColor: '#1e40af',
  darkToggleActiveIconColor: '#e2e8f0',
  darkToggleActiveBorderColor: '#3b82f6',
  darkToggleGlowColor: 'rgba(59, 130, 246, 0.4)',
};
